/* istanbul ignore file */

export * from './useContentfulContentTypeEntryFactory';
